import {ArrowDownIcon} from "@v2/icons";
import {DivisionSelector, DivisionSelectorProps} from "@v2/components/divisions/DivisionSelector/DivisionSelector";
import React from "react";

export const MobileDivisionSelector: React.FC<DivisionSelectorProps> = (props) => {
    return <DivisionSelector
        trigger={
            <>
            <span className="flex-1 min-w-0 font-bold text-[18px] max-w-[200px] truncate">
                {props.selectedOffice?.name}{' '}
                </span>
                <ArrowDownIcon className={'size-4 transition-opacity shrink-0'}/>
            </>
        }
        {...props}
        />;
        }